import { ICommonFormProps } from '@src/components/DynamicForm';
import { FormLabel, MultiSelect, SingleSelect } from '@src/components/ui';
import { Controller, useFormState } from 'react-hook-form';

import { useSelectAccount } from './hooks';

export const FormSelectAccount = (props: Readonly<ICommonFormProps>) => {
    const {
        label,
        keyName,
        control,
        className,
        registerOptions,
        formProps,
        inputProperties,
    } = props;

    const {
        options,
        hasMore,
        isLoading,
        isFetching,
        loadMore,
        fetchAccounts,
        resetSearch,
    } = useSelectAccount();

    const { touchedFields, isSubmitted } = useFormState({ control });

    return (
        <div className={className}>
            <Controller
                control={control}
                name={keyName}
                render={({ field, fieldState: { error: fieldStateError } }) => {
                    // Use filtered errors prop if available, otherwise use fieldState error
                    // But only show if field has been touched or form submitted
                    const error = props.errors ?? fieldStateError;
                    const showError = Boolean(
                        error && (touchedFields[keyName] || isSubmitted)
                    );
                    const handleChange = (val: any) => {
                        const newValue = formProps?.isMulti
                            ? (val ?? [])
                            : (val ?? null);

                        field.onChange(newValue);
                        field.onBlur();

                        if (registerOptions?.onChange) {
                            registerOptions.onChange({
                                target: { value: newValue },
                            } as any);
                        }
                    };

                    return (
                        <>
                            {label && (
                                <FormLabel
                                    label={label}
                                    required={
                                        typeof registerOptions?.required ===
                                        'object'
                                            ? Boolean(
                                                  registerOptions.required.value
                                              )
                                            : Boolean(registerOptions?.required)
                                    }
                                />
                            )}

                            {formProps?.isMulti ? (
                                <MultiSelect
                                    field={{ ...field, onChange: handleChange }}
                                    options={options}
                                    hasMore={hasMore}
                                    loadMore={loadMore}
                                    loading={isLoading || isFetching}
                                    placeholder={
                                        inputProperties?.placeholder ??
                                        'Select accounts'
                                    }
                                    allowClear={formProps?.allowClear}
                                    onSearch={fetchAccounts}
                                    onClear={() => resetSearch()}
                                />
                            ) : (
                                <SingleSelect
                                    field={{ ...field, onChange: handleChange }}
                                    options={options}
                                    hasMore={hasMore}
                                    loadMore={loadMore}
                                    loading={isLoading || isFetching}
                                    placeholder={
                                        inputProperties?.placeholder ??
                                        'Select an account'
                                    }
                                    allowClear={formProps?.allowClear}
                                    onSearch={fetchAccounts}
                                    onClear={() => resetSearch()}
                                />
                            )}

                            {showError && error?.message && (
                                <div className="text-red-500 text-sm mt-0">
                                    {error.message}
                                </div>
                            )}
                        </>
                    );
                }}
            />
        </div>
    );
};
